import { useInfiniteQuery } from '@tanstack/react-query';
import type { RequestOptions } from './api';
import { useApi } from './auth';

// Listes paginées par curseur (spec 08 : pagination serveur) : « Afficher plus » ajoute la page suivante.

type Query = NonNullable<RequestOptions['query']>;

export function useCursorList<Item>(path: string, query: Query = {}, limit = 50) {
  const api = useApi();
  const result = useInfiniteQuery({
    queryKey: [path, { ...query, limit, list: true }],
    initialPageParam: null as string | null,
    queryFn: ({ pageParam }) =>
      api.get<{ items: Item[]; nextCursor: string | null }>(path, {
        ...query,
        limit,
        ...(pageParam ? { cursor: pageParam } : {}),
      }),
    getNextPageParam: (last) => last.nextCursor,
  });
  return {
    ...result,
    items: result.data?.pages.flatMap((p) => p.items) ?? [],
  };
}
